import React, { useEffect, useState } from 'react';

import { Button, Card, Col, Container, Form, FormCheck, Row } from 'react-bootstrap';
import { Link, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import BreadCrumb from '../../Common/BreadCrumb';
import { useProductReviewsListQuery, useReplyReviewMutation, useUpdateReviewMutation } from '../../Redux/ReviewSlice';
import userDummy from '../../assets/images/userDummy.jpg';
import plusIcon from '../../assets/images/plus-icon.jpg';
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


import { getQueryString } from '../../lib/Validationtext';
import Ratings from './Rating';

const ReviewsRating = ({ reviews }) => {

  document.title = "Reviews & Ratings | Toner eCommerce + Admin React Template";
  let { id } = useParams()
  const [currentPage, setCurrentPage] = useState(1);
  const { data: listData, error: listErr, isLoading: listLoading, refetch } = useProductReviewsListQuery(getQueryString({ page: currentPage, limit: 5, productId: id }))
  const [pagination, setPagination] = useState(true);
  const perPageData = 9;
  const handleClick = (e) => {
    setCurrentPage(Number(e.target.id));
  };
  const indexOfLast = currentPage * perPageData;
  const indexOfFirst = indexOfLast - perPageData;
  const pageNumbers = Array(listData?.additional?.pageSize || 0).fill('').map((_, i) => i + 1)
  const [expandedCards, setExpandedCards] = useState({});

  const toggleExpand = (cardId) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardId]: !prev[cardId],
    }));
  };

  const handleprevPage = () => {
    let prevPage = currentPage - 1;
    setCurrentPage(prevPage);
  };

  const handlenextPage = () => {
    let nextPage = currentPage + 1;
    setCurrentPage(nextPage);
  };

  useEffect(() => {
    if (pageNumbers.length && pageNumbers.length < currentPage) {
      setCurrentPage(pageNumbers.length)
    }
  }, [currentPage, pageNumbers.length]);

  const [reviewsUsersIds, setReviewsUsersIds] = useState([]);
  const [reviewsWithIds, setReviewsWithIds] = useState({});

  useEffect(() => {
    if (listData?.response?.length) {
      setReviewsUsersIds([]);
      setReviewsWithIds({})
      listData?.response?.filter(r => r?.ReviewReply?.id)?.map(y => {
        setReviewsWithIds(prev => ({ ...prev, [y?.id]: y?.ReviewReply?.replyText }))
        setReviewsUsersIds(prev => ([...prev, y?.id]))
      })
    }

  }, [listData?.response])

  const [replyFn, { data: replyData, isLoading, isError, error, isSuccess: replySuccess }] = useReplyReviewMutation();
  const [updateReviewFn, { data: updateReviewData, isLoading: load, isError: iserror, error: Error, isSuccess: updateReviewSuccess }] = useUpdateReviewMutation();

  useEffect(() => {
    if (replySuccess) {
      const message = replyData?.message || "Reply Review successfully";
      toast.success(message);
    }
    if (error) {
      if ('data' in error) {
        const errorData = error;
        toast.error(errorData.data.message);

      }
    }
  }, [replyData, replySuccess, error]);

  useEffect(() => {
    if (updateReviewSuccess) {
      refetch()
      const message = updateReviewData?.message || "Update Review successfully";
      toast.success(message)
    }
    if (iserror && Error) {
      if ('data' in Error) {
        const errorData = Error;
        toast.error(errorData.data.message);

      }
    }
  }, [updateReviewData, updateReviewSuccess, Error]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalImgSrc, setModalImgSrc] = useState('');
  const [modalType, setModalType] = useState('Image');

  const openModal = (src, type) => {

    setModalVisible(true);
    setModalImgSrc(src);
    setModalType(type)
  };


  // const error={}
  let listContent = null;
  if (listLoading) {
    listContent = <p>Loading...</p>
  } else if (listErr && !listLoading) {
    listContent = <p>Something went wrong</p>
  } else if (listData?.response?.length == 0) {
    console.log('length')
    listContent =
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Reviews & Ratings" pageTitle="More" />
          <Row>
            <Row id="categories-list">
              <h5 className=" mb-0 text-center">No Product Rating Available</h5>
            </Row>
          </Row>
        </Container>
      </div>
  }
  else if (!listErr && !listLoading && listData?.response?.length > 0) {
    listContent = <>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Reviews & Ratings" pageTitle="More" />
          <Row>
            <Row id="categories-list">
              {listData?.response?.map((item, key) => (
                <Col xxl={4} md={6} key={key}>
                  <Card className='mx-2 my-2' key={key}>
                    <Card.Body>
                      <div class="d-flex align-items-center justify-content-between"  >
                        <img src={item.User?.profileImage != null ? item.User?.profileImage?.url : userDummy} alt="" className="avatar-sm rounded" />
                        <FormCheck label='Approved' checked={item.isApproved} onClick={() => {
                          updateReviewFn({ ...item, isApproved: !item.isApproved })
                        }} />
                      </div>
                      <h5 className="mb-2 mt-3">{item?.User?.firstName + " " + item?.User?.lastName}</h5>
                      <div className="text-warning mb-3">
                        <Ratings rating={item.rating} />
                      </div>
                      <p className="mb-0 text-muted fs-15"><b>{item.reviewTitle}</b></p>
                      <p className="mb-0 text-muted fs-15">{item.reviewText}</p>

                      {/* 
                      <div className="d-flex flex-wrap gap-2 my-3">
                        {item?.image != null ? (
                          item?.image.slice(0, expandedCards[item.id] ? item?.image.length : 4).map((image, index) => (
                            <img
                              key={index}
                              src={image?.url != null ? image?.url : userDummy}
                              alt=""
                              className="avatar-sm"
                              style={{ marginRight: '5px' }}
                              onClick={() => openModal(image?.url, 'Snow')}
                            />
                          ))
                        ) : (
                          <img src={userDummy} alt="" className="avatar-sm" />
                        )}

                        {item?.image != null && item?.image.length > 4 && (
                          <div className="plus-icon"
                            onClick={() => toggleExpand(item.id)}
                          >
                            {!expandedCards[item.id] &&
                              <img src={plusIcon} alt="" className="avatar-sm border-review" />
                            }
                          </div>
                        )}
                      </div> */}
                      <div className="d-flex flex-wrap gap-2 my-3">
                        {item?.image.slice(0, expandedCards[item.id] ? item?.image.length : 4).map((item, index) => (
                          <div key={index}>
                            {item?.fileName?.endsWith('.mp4') ? (
                              <video
                                controls

                                className="avatar-sm"
                                style={{ marginRight: '5px', cursor: 'pointer' }}
                                onClick={() => openModal(item?.url, 'Video')}
                              >
                                <source src={item.url} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            ) : (
                              <img
                                src={item?.url != null ? item?.url : userDummy}
                                alt=""
                                className="avatar-sm"
                                style={{ marginRight: '5px', }}
                                onClick={() => openModal(item?.url, 'Image')}
                              />
                            )}
                          </div>
                        ))}


                        {item?.image != null && item?.image.length > 4 && (
                          <div className="plus-icon"
                            onClick={() => toggleExpand(item.id)}
                          >
                            {!expandedCards[item.id] &&
                              <img src={plusIcon} alt="" className="avatar-sm border-review" />
                            }
                          </div>
                        )}
                      </div>



                      <div className="">
                        <p style={{
                          color: 'blue',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                        }} onClick={() => setReviewsUsersIds(prev => (prev?.includes(item?.id) ? prev?.filter(rId => rId !== item?.id) : [...prev, item?.id]))}>Reply</p>
                      </div>


                      {reviewsUsersIds?.includes(item?.id) &&
                        <div className="mt-3">
                          <Form.Label className="form-label">Review Reply</Form.Label>
                          <textarea className={`form-control  ${error?.message && 'is-invalid'}`} value={reviewsWithIds[item?.id]} onChange={e => setReviewsWithIds(prev => ({ ...prev, [item?.id]: e.target.value }))} rows={1} ></textarea>
                          <div className="invalid-feedback">{error?.message}</div>

                          <Button className='mt-3 btn-info' onClick={() => {
                            const sentData = { reviewID: item?.id, replyText: reviewsWithIds[item?.id] }
                            if (item?.ReviewReply?.id) {
                              sentData.id = item.ReviewReply?.id
                            }
                            replyFn(sentData)
                          }}>Send</Button>
                        </div>
                      }


                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>



          </Row>
        </Container>
      </div>
      {pagination &&
        <Container fluid>
          <Row id="pagination-element" className='mb-5'>
            <Col lg={12}>
              <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                <div className={currentPage <= 1 ? "page-item disabled" : "page-item"}>
                  <Button variant="link" href="#" className="page-link" id="page-prev" onClick={() => handleprevPage()}>←</Button>
                </div>
                <span id="page-num" className="pagination">
                  {pageNumbers.map((item, key) => (
                    <React.Fragment key={key}>
                      <div className={currentPage === item ? "page-item active" : "page-item"}>
                        <Link className="page-link clickPageNumber" to="#" key={key} id={item} onClick={(e) => handleClick(e)}>
                          {item}
                        </Link>
                      </div>
                    </React.Fragment>
                  ))}
                </span>
                <div className={currentPage >= pageNumbers.length ? "page-item disabled" : "page-item"}>
                  <Button variant="link" href="#" className="page-link" id="page-next" onClick={() => handlenextPage()}>→</Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      }


      {modalVisible && (
        <Modal
          show={modalVisible}
          onHide={() => setModalVisible(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton />
          <Modal.Body style={{ textAlign: 'center' }}>
            {modalType === 'Image' ? (
              <img src={modalImgSrc} alt="Modal Image" style={{ maxWidth: '100%' }} />
            ) : modalType === 'Video' ? (
              <video controls >
                <source src={modalImgSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setModalVisible(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  }

  return (
    <React.Fragment>
      {listContent}
    </React.Fragment>
  )
}

export default ReviewsRating;
